import firebase from 'firebase/app'
import 'firebase/auth'

if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: 'vue-galaxie-register.firebaseapp.com',
    databaseURL: 'https://vue-galaxie-register.firebaseio.com',
    projectId: 'vue-galaxie-register',
    storageBucket: 'vue-galaxie-register.appspot.com',
    messagingSenderId: '942579675481',
    appId: '1:942579675481:web:62183049f7eede5efc5c48',
  })

  firebase
    .auth()
    .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
    .catch((err) => console.error('Failed to set auth persistence:', err))
}

export default firebase
